import { render, staticRenderFns } from "./ReportOccupancyrate.vue?vue&type=template&id=15bac592&scoped=true&"
import script from "./ReportOccupancyrate.vue?vue&type=script&lang=js&"
export * from "./ReportOccupancyrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bac592",
  null
  
)

export default component.exports